import React, { Component } from 'react'
import { Col, Row } from 'reactstrap'
import TableColumnPreferenceControl from "../../Material/TableColumnPreferenceControl"
import ActionsPopup from "./ActionsPopup"
import withApolloClient from '../../withApolloClient'
import './DriversListContainer.css'

class DriverActions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            loading: false,
            allSelectedInList: false,
        }
    }
    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName, error: "" })
    }

    handleSelectAllInList = () => {
        this.setState({ allSelectedInList: true })
    };
    handleUnselectAllInList = () => {
        if (this.state.allSelectedInList) {
            this.setState({ allSelectedInList: false })
        } else {
            this.props.resetSelectedDrivers()
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.selectedDrivers !== this.props.selectedDrivers) {
            this.setState({ allSelectedInList: false })
        }
    }

    render() {
        return (
            <Row>
                <Col xs={12} className="text-right mt-3">
                    {this.props.activeTab !== "Schedules" && <>
                        <TableColumnPreferenceControl
                            tableId={this.props.tableId}
                            columnConfig={this.props.columnConfig}
                            setColumnConfig={this.props.setColumnConfig}
                            defaultColumnConfig={this.props.defaultColumnConfig}
                        />&nbsp;&nbsp;&nbsp;&nbsp;
                    </>}
                    <ActionsPopup
                        activeTab={this.props.activeTab}
                        selectedDrivers={this.props.selectedDrivers}
                        filterValues={this.props.filterValues}
                        allSelectedInList={this.state.allSelectedInList}
                        columnConfig={this.props.columnConfig}
                        totalDriverCount={this.props.totalDriverCount}
                        refetchQuery={this.props.refetchQuery}
                        resetSelectedDrivers={this.handleUnselectAllInList}
                        disableLegacyMessage={this.props.disableLegacyMessage}
                    />
                </Col>
                {this.props.selectedDrivers && this.props.selectedDrivers.length > 0 && <Col xs={12} className="mt-2 text-right">
                    <span className="search-filter-preview">
                        <span><i className="fa fa-times-circle" onClick={this.handleUnselectAllInList}></i>&nbsp;&nbsp; Selected Drivers</span>
                        {this.state.allSelectedInList ? `All ${this.props.totalDriverCount} in this list` : this.props.selectedDrivers.length === this.props.driverCountOnPage ? `All ${this.props.driverCountOnPage} on this page` : this.props.selectedDrivers.length}
                    </span>
                </Col>}
                {this.props.selectedDrivers && this.props.selectedDrivers.length > 0 && ["Collections", "Bad Debt"].includes(this.props.activeTab) && !this.state.allSelectedInList && this.props.totalDriverCount > this.props.selectedDrivers.length && this.props.selectedDrivers.length === this.props.driverCountOnPage &&
                    <Col xs={12} className="mt-2 text-right">
                        <a className={"select-all-button"} onClick={this.handleSelectAllInList}>
                            {`Select all ${this.props.totalDriverCount} drivers in this list`}
                        </a>
                    </Col>}
            </Row>
        )
    }
}


//-----------------------------------
export default withApolloClient(DriverActions)
